import React from "react";
import {
  Box,
  Typography,
  Modal,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";
import GroupedSizeDropdown from "./GroupedSizeDropwdown";
import FlavorDropdown from "./FlavorDropdown";
import DisclaimersBox from "./DisclaimersBox";
import CakeCustomizationForm from "./CakeCustomizationForm";

const RightColumn = ({
  cake,
  selectedSize,
  setSelectedSize,
  selectedFlavor,
  setSelectedFlavor,
  showFlavorModal,
  setShowFlavorModal,
  totalPrice,
  handleAddToCart,
  priceLoading,
  customizations,
  setCustomizations,
  onResetCustomizations,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <Typography variant="h4" sx={{ mb: 2 }}>
        {cake.displayName}
      </Typography>
      <Typography variant="h6" color="primary" sx={{ mb: 2 }}>
        Starting at ${cake.basePrice.toFixed(2)} CAD
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        {cake.description}
      </Typography>

      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          p: 3,
          mt: 2,
        }}>
        <GroupedSizeDropdown
          sizes={cake.sizes}
          selectedSizeId={selectedSize}
          onChange={(e) => setSelectedSize(e.target.value)}
        />

        <Box mt={3}>
          <FlavorDropdown
            flavors={cake.flavors}
            selectedFlavorId={selectedFlavor}
            onChange={(e) => setSelectedFlavor(e.target.value)}
          />
        </Box>

        {cake.customizationFields?.length > 0 && (
          <CakeCustomizationForm
            fields={cake.customizationFields}
            values={customizations}
            setValues={setCustomizations}
            onResetCustomizations={onResetCustomizations}
          />
        )}

        <DisclaimersBox disclaimers={cake.disclaimers} />
      </Box>

      {/* Mobile-only Add to Cart */}
      {isMobile && (
        <Box
          sx={{
            mx: "auto",
            maxWidth: "100%",
            mt: 4,
          }}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            disabled={!selectedSize || !selectedFlavor || priceLoading}
            onClick={handleAddToCart}
            sx={{
              py: 1.5,
              fontWeight: 600,
              fontSize: "1rem",
              borderRadius: "10px",
            }}>
            {priceLoading
              ? "Calculating..."
              : `Add to Cart ($${totalPrice.toFixed(2)})`}
          </Button>
          {(!selectedSize || !selectedFlavor) && !priceLoading && (
            <Typography
              variant="caption"
              sx={{
                mt: 1,
                color: "#999",
                textAlign: "center",
                display: "block",
                fontStyle: "italic",
              }}>
              Make your selections above to enable this button
            </Typography>
          )}
        </Box>
      )}

      {/* Flavor Modal */}
      <Modal open={showFlavorModal} onClose={() => setShowFlavorModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "white",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            minWidth: 400,
          }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Flavor Details
          </Typography>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Inside Icing</TableCell>
                <TableCell>Outside Icing</TableCell>
                <TableCell>Price (CAD)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cake.flavors.map((flavor) => (
                <TableRow key={flavor._id}>
                  <TableCell>{flavor.displayName}</TableCell>
                  <TableCell>{flavor.icing?.name || "-"}</TableCell>
                  <TableCell>Buttercream</TableCell>
                  <TableCell>${flavor.price.toFixed(2)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Modal>
    </>
  );
};

export default RightColumn;
